var hooxSliderUgc = document.querySelectorAll('.hoox-ugc-videos__items');

if (!!hooxSliderUgc.length) {
  hooxSliderUgc = Array.from(hooxSliderUgc);

  hooxSliderUgc.forEach(element => {
    var slides = element.querySelectorAll('.swiper-slide');
    var swiperOptions = {
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      pagination: {
        el: '.hoox-ugc-videos .hoox-swiper-dots',
        clickable: true
      },
      navigation: {
        nextEl: '.hoox-ugc-videos .hoox-swiper-arrow-next',
        prevEl: '.hoox-ugc-videos .hoox-swiper-arrow-prev',
      }
    };

    if (window.innerWidth < 1023 && slides.length > 1) {
      new Swiper(element, swiperOptions);
    } else if (window.innerWidth >= 1023 && slides.length > 3) {
    
      swiperOptions.breakpoints = {
        767: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 40, 
          watchOverflow: true
        }
      };
      new Swiper(element, swiperOptions);
    } else {
      var navigation = element.querySelector('.hoox-swiper-navigation');
      if (navigation) {
        navigation.style.display = 'none';
        navigation.style.height = '0';
      }

      element.classList.add('swiper-unitialized');
    }
  });
}

